import { PathFinderWorkerInterface } from '../workers/PathFinderWorkerInterface-sidecar'
import { PathFinderWorkerInterface2 } from '../workers/PathFinderWorkerInterface2-sidecar'
import { LevelShip, LevelSpace } from '../workers/PathFinder2'

export type PathSpotType = { x: number; y: number }

export type PathType = PathSpotType[]

export const findPath = (
  sx: number,
  sy: number,
  ex: number,
  ey: number,
  insideShip: boolean,
  allowNextTo: boolean,
  callback: (path: PathType) => void,
) => {
  // console.log('finding path', sx, sy, ex, ey)

  return PathFinderWorkerInterface2.findPath(
    sx,
    sy,
    insideShip ? LevelShip : LevelSpace,
    ex,
    ey,
    insideShip ? LevelShip : LevelSpace,
    allowNextTo,
    (result) => {
      let path: PathType = []
      for (let i = 0; i < result.result.path.length; i++) {
        let p = result.result.path[i]
        // TODO: make this better
        path.push({
          x: p.i,
          y: p.j,
        })
      }

      callback(path)
    },
  )

  // return PathFinderWorkerInterface.findPath(
  //   sx,
  //   sy,
  //   ex,
  //   ey,
  //   insideShip,
  //   (path) => {
  //     if (callback) {
  //       callback(path)
  //     }
  //   },
  // )
}
